import React from 'react'

type SunIconSvgProps = React.ComponentPropsWithoutRef<'svg'>

const SunIconSvg = ({ ...props }: SunIconSvgProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6Z"
        fill="currentColor"
      />
      <path
        d="M3.5148 3.51475C3.0456 3.98275 3.0456 4.74242 3.5148 5.21162C3.984 5.68082 4.7436 5.68082 5.2116 5.21162C5.6808 4.74242 5.6808 3.98275 5.2116 3.51475C4.7436 3.04555 3.984 3.04555 3.5148 3.51475Z"
        fill="currentColor"
      />
      <path
        d="M20.4852 20.4853C20.9544 20.0161 20.9544 19.2564 20.4852 18.7884C20.0172 18.3192 19.2564 18.3192 18.7884 18.7884C18.3192 19.2564 18.3192 20.0161 18.7884 20.4853C19.2564 20.9533 20.0172 20.9533 20.4852 20.4853Z"
        fill="currentColor"
      />
      <path
        d="M5.2116 20.4853C5.6808 20.0161 5.6808 19.2564 5.2116 18.7884C4.7436 18.3192 3.984 18.3192 3.5148 18.7884C3.0456 19.2564 3.0456 20.0161 3.5148 20.4853C3.984 20.9533 4.7436 20.9533 5.2116 20.4853Z"
        fill="currentColor"
      />
      <path
        d="M20.4852 5.21162C20.9544 4.74242 20.9544 3.98275 20.4852 3.51475C20.0172 3.04555 19.2564 3.04555 18.7884 3.51475C18.3192 3.98275 18.3192 4.74242 18.7884 5.21162C19.2564 5.68082 20.0172 5.68082 20.4852 5.21162Z"
        fill="currentColor"
      />
      <path
        d="M1.2 13.2C1.8624 13.2 2.4 12.6624 2.4 12C2.4 11.3376 1.8624 10.8 1.2 10.8C0.5376 10.8 0 11.3376 0 12C0 12.6624 0.5376 13.2 1.2 13.2Z"
        fill="currentColor"
      />
      <path
        d="M22.8 13.2C23.4624 13.2 24 12.6624 24 12C24 11.3376 23.4624 10.8 22.8 10.8C22.1376 10.8 21.6 11.3376 21.6 12C21.6 12.6624 22.1376 13.2 22.8 13.2Z"
        fill="currentColor"
      />
      <path
        d="M12 24C12.6624 24 13.2 23.4624 13.2 22.8C13.2 22.1376 12.6624 21.6 12 21.6C11.3376 21.6 10.8 22.1376 10.8 22.8C10.8 23.4624 11.3376 24 12 24Z"
        fill="currentColor"
      />
      <path
        d="M12 0C11.3376 0 10.8 0.5376 10.8 1.2C10.8 1.8624 11.3376 2.4 12 2.4C12.6624 2.4 13.2 1.8624 13.2 1.2C13.2 0.5376 12.6624 0 12 0Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const SunIcon = React.memo(SunIconSvg)
